<template>
  <div class="wrapper">
    <div class="clause-wrap">
      <header class="top-head border-1px">
        <h1>Email</h1>
      </header>
      <div class="imgwrap">
        <img src="../../assets/common/img/icon_e-mail.png" alt="" />
      </div>
      <div class="msgWrap">
       <h2>Successfully sent</h2>
       <p>Your policy will be sent to your email within 60 minutes.
         Please log in to your email to download
       </p>
       </div>
       <div class="sendsuccesswrap">
            <mt-button type="default" @click.native="handleReturn">Return to Policy detail</mt-button>
        </div>
    </div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Header } from 'mint-ui';
// import { Button } from 'mint-ui';

Vue.component(Header.name, Header)
Vue.component(Button.name, Button);
// Vue.use(Field)
export default {
  name: 'insurancePolicy',
  data() {
    return {
      I18n: window.I18n,
      username: 'Policy verification',
      email: '',
      password: '',
      phone: '',
      website: '',
      number: '',
      birthday: '',
      introduction: ''
    };
  },
  methods: {
    handleReturn() {
      this.$router.push({
        name: 'PolicyDetail',
        query: { policyId: this.policyId }
      })
    }
  },
  created() {
    this.policyId = this.$route.query.policyId
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "./style/index.styl";
</style>



// WEBPACK FOOTER //
// src/pages/SendSuccess/index.vue